<span class="localization-modal">
    <div class="modal-body">
        <app-icon
            [type]="'X'"
            class="close-modal"
            (click)="activeModal.dismiss()"
        ></app-icon>
        <img [src]="logoImage" class="logo" alt="PBS LeaningMedia Logo" />
        <div class="view1" *ngIf="shouldShowZipPrompt()">
            <h5 class="modal-title">Find Your Local Station</h5>
            <p class="description">
                Using your ZIP code, choose a local PBS station to see
                educational resources and station-sponsored events near you.
                Sign in to see each resource aligned to your state's educational
                standards.
            </p>
            <div class="inputs">
                <input
                    (keypress)="keyPress($event)"
                    [(ngModel)]="zipCode"
                    type="text"
                    class="zip-input"
                    placeholder="School ZIP Code"
                />
                <app-button
                    [disable]="!(zipCode.length >= 5)"
                    (click)="submitZipCode()"
                    class="confirm-btn"
                    buttonClasses="gtm-loc-modal-search-by-zipcode"
                >
                    Search by ZIP Code
                </app-button>
            </div>
            <div
                class="states-selector-wrapper inputs"
                *ngIf="useNewLocalization()"
            >
                <ng-select
                    [items]="states"
                    bindLabel="name"
                    dropdownPosition="bottom"
                    [multiple]="false"
                    [hideSelected]="true"
                    [searchable]="false"
                    [clearable]="false"
                    [markFirst]="true"
                    placeholder="Select State"
                    [(ngModel)]="selectedState"
                    class="dropdown"
                >
                </ng-select>
                <app-button
                    (click)="submitState()"
                    buttonClasses="gtm-loc-modal-search-by-state"
                    class="confirm-btn"
                    >Search by State</app-button
                >
            </div>
        </div>
        <div class="view2" *ngIf="shouldShowStationsPrompt()">
            <div class="info-wrapper">
                <div>
                    <h5 class="modal-title">Choose Your Local Station</h5>
                    <div class="description">
                        Find resources designed for teachers in your area and
                        discover nearby station-sponsored events.
                    </div>
                </div>

                <div class="logo-wrapper">
                    <img
                        class="station-logo"
                        *ngIf="stationLogo"
                        [src]="stationLogo"
                        alt="station logo"
                    />
                    <div
                        class="city-state"
                        *ngIf="
                            selectedStation &&
                            selectedStation.city &&
                            selectedStation.state
                        "
                    >
                        {{ selectedStation.city }}, {{ selectedStation.state }}
                    </div>
                </div>
            </div>

            <p class="warning" *ngIf="!zipcodeHasMatched">
                There are no stations available for your selected zip code. You
                may choose one of the following.
            </p>
            <div class="stations-wrapper">
                <div
                    class="station"
                    *ngFor="let station of stations"
                    (click)="selectStation(station)"
                    [ngClass]="{
                        selected: selectedStation === station || index
                    }"
                >
                    {{ station.organizationName }}
                    <div class="standards" *ngIf="station.authorities.length">
                        State Standards: {{ station.authorities.join(",") }}
                    </div>
                </div>
                <div
                    class="station"
                    *ngIf="shouldShowVirginiaPrompt()"
                    (click)="selectEmediaVa()"
                    [ngClass]="{ selected: selectedEMediaVA }"
                >
                    eMediaVA (external link)
                    <div class="standards">State Standards: Virginia</div>
                </div>
            </div>

            <div class="note">
                Please note: You must be signed in to see state standards.
            </div>
            <div class="action-buttons-wrapper">
                <app-button class="back-btn" (click)="goBackToZipCodeView()">
                    <app-icon [type]="'Arrow-left'"></app-icon> Change ZIP Code
                    / State
                </app-button>
                <app-button (click)="submitStation()" class="confirm-btn"
                    >Confirm My Local Station</app-button
                >
            </div>
        </div>
    </div>
</span>
